module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isDataAvailable) ? _c('loader', {
    staticStyle: {
      "min-height": "100px"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label text-label"
  }, [_vm._v("Status History")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.isDataAvailable) ? _c('div', {
    staticStyle: {
      "float": "clear"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.gridWorkFlowInstanceStatus.tableData,
      "columns": _vm.gridWorkFlowInstanceStatus.columns,
      "options": _vm.gridWorkFlowInstanceStatus.options
    }
  })], 1) : _vm._e()])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a699728"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/WorkflowHistory.vue
// module id = 892
// module chunks = 1